import React from 'react';
import cx from 'classnames';

const TextEditorView = ({ content, className }) => (
    <div className={cx('ql-viewer', 'ql-editor', className)} dangerouslySetInnerHTML={{ __html: content }} />
);

export default TextEditorView;
